/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Signup__TermsInputs */

const en_auth__signup__terms = /** @type {(inputs: Auth__Signup__TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By creating an account, you agree to our Terms of Use and acknowledge our Privacy Policy. Depending on how you use Bidbattles, we may send you promotional emails. For more information or to unsubscribe, please see our Privacy Policy.`)
};

/**
* | output |
* | --- |
* | "By creating an account, you agree to our Terms of Use and acknowledge our Privacy Policy. Depending on how you use Bidbattles, we may send you promotional em..." |
*
* @param {Auth__Signup__TermsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__signup__terms = /** @type {((inputs?: Auth__Signup__TermsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Signup__TermsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__signup__terms(inputs)
});